import { IReviewQuizModel } from '../interfaces/Review-Quiz';

export const ReviewQuizInitialState: IReviewQuizModel = {
  isLoading: true,
  quizData: {},
  quizSummaryData: {},
  isError: false,
};
